export default "__VITE_PUBLIC_ASSET__3cdb717a__"